import React from 'react';
import Navbar from '../../components/Navbar';
import { AlertTriangle, AlertOctagon, Info } from 'lucide-react';

const RiskDisclosure = () => {
    return (
        <div className="bg-[#0b0e11] min-h-screen text-gray-100 font-sans selection:bg-blue-500/30">
            <Navbar />

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="text-center mb-16">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 text-red-500 mb-6">
                        <AlertTriangle size={32} />
                    </div>
                    <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Risk Disclosure</h1>
                    <p className="text-red-400 max-w-2xl mx-auto font-medium">
                        Cryptocurrency trading involves substantial risk and is not suitable for every investor.
                    </p>
                </div>

                <div className="bg-[#181a20] rounded-3xl border border-red-900/20 overflow-hidden">
                    <div className="bg-red-500/5 p-6 border-b border-red-900/20">
                        <p className="text-gray-300 leading-relaxed">
                            This Risk Disclosure Statement provides you with information about the risks associated with the services provided by Albatech. You should read this statement carefully before using our services.
                        </p>
                    </div>

                    <div className="p-8 sm:p-12 space-y-10">

                        <section>
                            <h3 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                                <AlertOctagon size={20} className="text-red-500" />
                                1. Market Volatility
                            </h3>
                            <p className="text-gray-400 pl-7 text-sm sm:text-base leading-relaxed">
                                The value of cryptocurrencies can be extremely volatile and unpredictable. Prices can fluctuate significantly in short periods, potentially resulting in the total loss of your investment.
                            </p>
                        </section>

                        <section>
                            <h3 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                                <AlertOctagon size={20} className="text-red-500" />
                                2. Regulatory Risk
                            </h3>
                            <p className="text-gray-400 pl-7 text-sm sm:text-base leading-relaxed">
                                The regulatory environment for cryptocurrencies is evolving. Changes in laws and regulations may adversely affect the value of cryptocurrencies or your ability to trade them.
                            </p>
                        </section>

                        <section>
                            <h3 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                                <AlertOctagon size={20} className="text-red-500" />
                                3. Technology Risk
                            </h3>
                            <p className="text-gray-400 pl-7 text-sm sm:text-base leading-relaxed">
                                Using blockchain technology and online trading platforms involves risks such as software failures, hardware failures, and internet connection issues. We cannot guarantee that our services will be uninterrupted or error-free.
                            </p>
                        </section>

                        <section>
                            <h3 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                                <AlertOctagon size={20} className="text-red-500" />
                                4. Cybersecurity Risk
                            </h3>
                            <p className="text-gray-400 pl-7 text-sm sm:text-base leading-relaxed">
                                While we implement robust security measures, the nature of digital assets makes them targets for cyberattacks, hacking, and phishing. You are responsible for securing your own account credentials and devices.
                            </p>
                        </section>

                        <section>
                            <h3 className="text-lg font-bold text-white mb-3 flex items-center gap-2">
                                <AlertOctagon size={20} className="text-red-500" />
                                5. Liquidity Risk
                            </h3>
                            <p className="text-gray-400 pl-7 text-sm sm:text-base leading-relaxed">
                                Markets for some cryptocurrencies may be illiquid. You may not be able to sell your assets when you want to or at the price you expect.
                            </p>
                        </section>

                    </div>

                    <div className="bg-[#0b0e11] p-6 border-t border-gray-800 text-center">
                        <p className="text-gray-500 text-sm">
                            By using Albatech services, you acknowledge that you have read, understood, and accepted these risks.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RiskDisclosure;
